<script setup lang="ts">
import { nextTick, ref } from "vue";
import { type ScrollAxis, type ScrollContainer, scrollToCenter } from "./scrollToCenter";

export interface Props {
	axis: ScrollAxis;
	behavior: ScrollBehavior;
	container: ScrollContainer;
	pdfMode?: boolean;
}

const props = withDefaults(defineProps<Props>(), { pdfMode: false });

defineSlots<{
	default(props: { handleTargetClick: (event: Event) => void; scrollToElement: (target: HTMLElement | null | undefined) => void }): unknown;
}>();

const wrapperRef = ref<HTMLElement | null>(null);

const scrollToElement = (target: HTMLElement | null | undefined) => {
	if (!wrapperRef.value || !target) return;
	scrollToCenter(target, { axis: props.axis, behavior: props.behavior, container: props.container });
};

const handleTargetClick = async (event: Event) => {
	const target = event.currentTarget as HTMLElement | null;
	await nextTick();
	scrollToElement(target);
};

defineExpose({ scrollToElement });
</script>

<template>
	<div ref="wrapperRef" class="scroll-to-wrapper tw:[display:inherit]" :class="{ 'scroll_pdf tw:select-none': pdfMode }">
		<slot :handleTargetClick="handleTargetClick" :scrollToElement="scrollToElement" />
	</div>
</template>
